<template>
  <div class="semester-config">
    <div class="semester-title d-flex align-center">
      <span class="mr-2">{{ index + 1 }}. {{ semester.title }}</span>
      <div class="toolbar d-inline-flex align-center">
        <v-btn icon small @click="onClickUpsertSemester(semester)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon small @click="onClickRemoveSemester(semester)">
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </div>
      <div class="flex-fill"></div>
      <v-btn v-if="!isEmpty" elevation="0" @click="onClickUpsertSemesterCourseConfig()"
        >Thêm môn học<v-icon class="mb-1" right>add</v-icon></v-btn
      >
    </div>
    <div class="course-configs">
      <v-data-table
        :dense="true"
        item-key="id"
        disableSort
        :headers="headers"
        :items="tableData"
        item-class="row-class"
        :disable-pagination="true"
        :mobile-breakpoint="0"
        :hide-default-header="isEmpty"
        :hide-default-footer="true"
        @click:row="onRowClick"
      >
        <template v-slot:no-data="">
          <div class="d-flex flex-column empty-content">
            <v-icon style="font-size: 2em">mdi-package-variant</v-icon>
            <p class="empty-text">Chưa có môn học nào</p>
            <v-btn elevation="0" @click="onClickUpsertSemesterCourseConfig()"
              >Thêm môn học<v-icon class="mb-1" right>add</v-icon></v-btn
            >
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex">
            <v-btn icon small @click="onClickUpsertSemesterCourseConfig(item)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon small @click="onClickRemoveSemesterCourse(item)">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </div>
    <BaseDialog
      v-if="upsertSemesterConfigDialog.isOpen"
      :isOpen="upsertSemesterConfigDialog.isOpen"
      :title="upsertSemesterConfigDialog.title"
      @close="upsertSemesterConfigDialog.isOpen = false"
      @cancel="upsertSemesterConfigDialog.onCancel"
      @confirm="upsertSemesterConfigDialog.callback"
    >
      <v-form lazy ref="semesterForm" @submit.prevent="upsertSemesterConfigDialog.callback()">
        <v-card-text v-if="upsertSemesterConfigDialog.currentItem" class="pa-4">
          <v-text-field
            v-model="upsertSemesterConfigDialog.currentItem.title"
            label="Tiêu đề"
            required
            class="mb-3"
            hide-details="auto"
            :rules="[$rules.required]"
          ></v-text-field>
        </v-card-text>
        <input type="submit" value="" class="d-none" />
      </v-form>
    </BaseDialog>
    <BaseDialog
      v-if="upsertSemesterCourseConfigDialog.isOpen"
      :isOpen="upsertSemesterCourseConfigDialog.isOpen"
      :title="upsertSemesterCourseConfigDialog.title"
      @close="upsertSemesterCourseConfigDialog.isOpen = false"
      @cancel="upsertSemesterCourseConfigDialog.onCancel"
      @confirm="upsertSemesterCourseConfigDialog.callback"
    >
      <v-form lazy ref="courseForm" @submit.prevent="upsertSemesterCourseConfigDialog.callback()">
        <v-card-text v-if="upsertSemesterCourseConfigDialog.currentItem" class="pa-4">
          <autocomplete-course
            filled
            clearable
            full-width
            single-line
            dense
            v-model="upsertSemesterCourseConfigDialog.currentItem.course"
            :rules="[$rules.required]"
          />
          <v-text-field
            v-model="upsertSemesterCourseConfigDialog.currentItem.multiplier"
            :rules="multiplierRules"
            type="number"
            label="Trọng số"
            required
            hide-details="auto"
          ></v-text-field>
        </v-card-text>
        <input type="submit" value="" class="d-none" />
      </v-form>
    </BaseDialog>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { cloneDeep } from 'lodash'
import BaseDialog from '@/components/base/BaseDialog'
import AutocompleteCourse from '@/components/basic/input/AutocompleteCourse'

export default {
  props: {
    semester: Object,
    index: Number
  },
  components: { BaseDialog, AutocompleteCourse },
  data() {
    return {
      multiplierRules: [this.$rules.required, this.$rules.min(0)],
      upsertSemesterConfigDialog: {
        isOpen: false,
        title: '',
        currentItem: null,
        callback: null,
        onCancel: () => {
          this.upsertSemesterConfigDialog.isOpen = false
        }
      },
      upsertSemesterCourseConfigDialog: {
        isOpen: false,
        title: '',
        currentItem: null,
        callback: null,
        onCancel: () => {
          this.upsertSemesterCourseConfigDialog.isOpen = false
        }
      }
    }
  },
  computed: {
    ...mapState('marksheet', ['semesterCourseConfigs']),
    tableData() {
      return this.semesterCourseConfigs
        .filter(i => i.semester_config.id === this.semester.id)
        .map((i, index) => ({ ...i, index: index + 1 }))
    },
    isEmpty() {
      return this.tableData.length === 0
    },
    headers() {
      return [
        { text: 'STT', value: 'index' },
        { text: 'Môn học', value: 'course.title' },
        { text: 'Trọng số', value: 'multiplier' },
        { text: 'Hành động', value: 'actions' }
      ]
    }
  },
  methods: {
    ...mapActions('marksheet', [
      'fetchSemesterCourseConfigs',
      'updateSemesterConfig',
      'createSemesterConfig',
      'updateSemesterCourseConfig',
      'createSemesterCourseConfig',
      'removeSemesterCourseConfig',
      'removeSemesterConfig'
    ]),
    onRowClick() {},
    onClickRemoveSemester(item) {
      this.$dialog.confirm({
        title: 'Xóa học kỳ',
        text: `Bạn có chắc chắn muốn xóa học kỳ này, dữ liệu bị xóa sẽ không thể khôi phục`,
        okText: 'Có',
        cancelText: 'Hủy',
        done: async () => {
          try {
            await this.removeSemesterConfig(item.id)
            this.$alert.success('Xóa thành công')
          } catch (error) {
            console.error(error)
            this.$alert.error('Có lỗi xảy ra')
          }
        }
      })
    },
    onClickRemoveSemesterCourse(item) {
      this.$dialog.confirm({
        title: 'Xóa cấu hình',
        text: `Bạn có chắc chắn muốn xóa cấu hình môn học này, dữ liệu bị xóa sẽ không thể khôi phục`,
        okText: 'Có',
        cancelText: 'Hủy',
        done: async () => {
          try {
            await this.removeSemesterCourseConfig(item.id)
            this.$alert.success('Xóa thành công')
          } catch (error) {
            console.error(error)
            this.$alert.error('Có lỗi xảy ra')
          }
        }
      })
    },
    onClickUpsertSemester(item) {
      this.upsertSemesterConfigDialog.isOpen = true
      this.upsertSemesterConfigDialog.title = item ? 'Sửa cấu hình học kỳ' : 'Tạo học kỳ mới'
      this.upsertSemesterConfigDialog.currentItem = item
        ? cloneDeep(item)
        : {
            title: `Học kỳ ` + (this.semesterCourseConfigs.length + 1),
            overall_mark_sheet: this.$route.params.id
          }
      this.upsertSemesterConfigDialog.callback = async () => {
        if (!this.$refs.semesterForm.validate()) {
          return
        }
        try {
          if (item) {
            await this.updateSemesterConfig(this.upsertSemesterConfigDialog.currentItem)
            this.$alert.success('Cập nhật thành công')
          } else {
            await this.createSemesterConfig({ data: this.upsertSemesterConfigDialog.currentItem })
            this.$alert.success('Tạo thành công')
          }
        } catch (error) {
          console.error(error)
          this.$alert.error('Có lỗi xay ra')
        } finally {
          this.upsertSemesterConfigDialog.isOpen = false
        }
      }
    },

    onClickUpsertSemesterCourseConfig(item) {
      this.upsertSemesterCourseConfigDialog.currentItem = cloneDeep(item) || {
        course: '',
        multiplier: 1,
        semester_config: this.semester.id
      }
      this.upsertSemesterCourseConfigDialog.title = item ? 'Sửa cấu hình' : 'Thêm môn học'
      this.upsertSemesterCourseConfigDialog.isOpen = true
      this.upsertSemesterCourseConfigDialog.callback = (async () => {
        if (!this.$refs.courseForm.validate()) {
          return
        }
        try {
          if (item) {
            await this.updateSemesterCourseConfig(this.upsertSemesterCourseConfigDialog.currentItem)
            this.$alert.success('Cập nhật thành công')
          } else {
            await this.createSemesterCourseConfig({
              data: this.upsertSemesterCourseConfigDialog.currentItem
            })
            this.$alert.success('Tạo thành công')
          }
        } catch (error) {
          console.error(error)
          this.$alert.error('Có lỗi xay ra')
        } finally {
          this.upsertSemesterCourseConfigDialog.isOpen = false
        }
      }).bind(this)
    }
  },
  created() {
    this.fetchSemesterCourseConfigs({ semesterId: this.semester.id })
  }
}
</script>
<style scoped>
.empty-content {
  width: fit-content;
  margin: auto;
}
.semester-config:not(:last-child) {
  margin-bottom: 20px;
}
</style>
